
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FileCategory } from "../types";

interface CategorySelectorProps {
  value: string;
  onChange: (value: string) => void;
  categories: FileCategory[];
}

export function CategorySelector({ value, onChange, categories }: CategorySelectorProps) {
  return (
    <div>
      <Label htmlFor="file-category">Κατηγορία</Label>
      <Select 
        value={value} 
        onValueChange={onChange}
      >
        <SelectTrigger className="w-full mt-1">
          <SelectValue placeholder="Επιλέξτε κατηγορία" />
        </SelectTrigger>
        <SelectContent>
          {categories.map((category) => (
            <SelectItem key={category.value} value={category.value}>
              {category.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
